// react
import axios, { AxiosResponse } from "axios";
import { saveAs } from "file-saver";
import hmacSHA512 from "crypto-js/hmac-sha512";
// config
import { TOKEN } from "src/config/config";
import { GEOCODING_RECORDS_FOR_1_CREDITS } from "src/config/credits";
import DATA from "src/config/search.json";
// handlers
import user from "src/components/UI/Shared/user";
// Data
import Store from "src/data/store";
const store = Store.getInstance();

class SharedHandler {
  public static download = async (blob: Blob, basename: string) => {
    const downloadUrl = URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = downloadUrl;
    a.download = basename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  public static fileDownloadHandler = async (
    response: any,
    basename: string,
    type: string
  ) => {
    const disposition = response.request.getResponseHeader(
      "Content-Disposition"
    );
    let blob = new Blob([response.data], { type: type });
    this.download(blob, basename);
  };
  public static createFileBlobHandler = (data: any, type: string) => {
    const fileBlob = new Blob([data], {
      type: type,
    });
    return fileBlob;
  };
  public static saveFile = async (blob: Blob, name: string) => {
    saveAs(blob, name);
  };
  public static signRequest = (
    url: string,
    method: string = "POST",
    timestamp: string
  ) => {
    let path = url;
    const secretKey = TOKEN;
    const signature = hmacSHA512(path + method + timestamp, secretKey);
    return signature.toString();
  };

  public static checkValidCoordinates = (coordinates: any) => {
    if (Array.isArray(coordinates)) {
      for (const item of coordinates) {
        if (Array.isArray(item)) {
          if (!this.checkValidCoordinates(item)) {
            return false;
          }
        } else if (item === null) {
          return false;
        }
      }
    } else if (coordinates === null) {
      return false;
    }
    return true;
  };
  public static handleRemoveLayer = (layerId: string) => {
    if (store.MapView) {
      store.MapView.map.layers.remove(store.MapView.map.findLayerById(layerId));
    }
  };
  public static decodeResponse = (response: AxiosResponse) => {
    let response_data;
    const textDecoder = new TextDecoder("utf-8");
    try {
      response_data = JSON.parse(textDecoder.decode(response.data));
    } catch {
      response_data = response.data;
    }
    return response_data;
  };
}
export default SharedHandler;

export const addCaptchaToLocalStorage = async (guid: string) => {
  const current_user = user.getCurrentLoggedIn();
  const data = localStorage.getItem(current_user);
  const _info = data !== null ? JSON.parse(data) : null;
  const new_data = _info;
  new_data.ip_data.guid = guid;
  localStorage.setItem(current_user, JSON.stringify(new_data));
};
export const addGotoNavigation = (ind: string) => {
  const current_user = user.getCurrentLoggedIn();
  const data = localStorage.getItem(current_user);
  const _info = data !== null ? JSON.parse(data) : null;
  const new_data = _info;
  new_data.ip_data.map = ind;
  localStorage.setItem(current_user, JSON.stringify(new_data));
};
export const SERVICES_KEYS = Object.keys(DATA.services);

export const _GetUrl = (category: number, item: number) => {
  const SERVICES_DATA = Object.values(DATA.services);
  return `${SERVICES_KEYS[category]}/${SERVICES_DATA[category][item].url}`;
};
export const _GetTitle = (category: number, item: number) => {
  const SERVICES_DATA = Object.values(DATA.services);
  return `${SERVICES_DATA[category][item].title}`;
};
export const _GetType = (category: number, item: number) => {
  const SERVICES_DATA = Object.values(DATA.services);
  return `${SERVICES_DATA[category][item].type}`;
};
export const calculatefileCost = (file: File | Blob, size?: number) => {
  let fileSize;
  if (size) fileSize = size;
  else fileSize = file.size;
  const mega = fileSize / (1024 * 1024);
  const megaSize = Math.ceil(mega);
  const cost = megaSize * 1;
  return cost;
};
export const calculateGeocodingFileCost = (records: number) => {
  if (records <= 0) return 0;
  else return Math.floor((records - 1) / GEOCODING_RECORDS_FOR_1_CREDITS) + 1;
};
export const reorder = <T>(
  list: T[],
  startIndex: number,
  endIndex: number
): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
